import angular from 'angular';

import TagModel from '../../models/tag';
import TagsTreeModel from '../../models/trees/tags';

class TagsCtrl {
  constructor($routeParams, $scope, $q, $filter, $timeout, Tag, TagsTree,
    $uibModal) {
    this.routeParams = $routeParams;
    this.openModal = $uibModal.open
    this.q = $q
    this.timeout = $timeout;
    this.filter = $filter('filter');
    this.orderBy = $filter('orderBy');
    this.model = Tag;
    this.scope = $scope;

    this.tags = TagsTree;

    // default view settings
    this.searchQuery = '';
    this.sortFilter = '-id';
    this.tagError = '';

    $scope.$on('tagError', (e, error) => {
      this.tagError = error;
      e.stopPropagation();
    });
    this.getTags();
    $scope.$on('$routeChangeSuccess', this.getTags);

    this.deleteTag = this.deleteTag.bind(this)
  }
  getTags() {
    if (this && this.routeParams.caseId) {
      this.tags.api.get().then(() => {
        this.filterTags();
      });
    }
  }
  createTag(displayName) {
    let promise = new this.model({ displayName }).api.create()
    promise.then(data => this.tags.add(data))
    return promise
  }
  updateTag(tag) {
    return new this.model(tag).api.update()
      .then(data => tag = Object.assign(tag, data))
  }
  deleteTag(tag) {
    const deferred = this.q.defer()

    this.openModal({
      template: require('./confirm-delete.html'),
      windowTemplateUrl: '/modals/default/modal-container.html',
    }).result.then(() => {
      new this.model(tag).api.delete().then(() => {
        this.tags.remove(tag)
        deferred.resolve()
      })
    }, () => { deferred.reject() })
    return deferred.promise
  }
  updateModel(data, isUpdate) {
    this.selectedTag.data = data;
    this.setDetail(this.selectedTag.data);

    var index = this.tags.data.map(
      tag => tag.id
    ).indexOf(this.selectedTag.data.id);

    if (index === -1) {
      this.tags.data.push(this.selectedTag.data);
    } else {
      this.tags.data[index] = this.selectedTag.data;
    }

    this.filterTags();
    // the tag list should be refreshed if updating a tag.
    // the filtered list should contain the new tag after adding,
    // regardless of filtering - temporarily add the new tag onto
    // the filtered list.
    // if (isUpdate) {
    //     this.filterTags();
    // } else if (!this.filteredTags.some(function (tag) {
    //         // test if new tag is in filtered list
    //         // special-case (when re-uploading a file)
    //         return tag.id === data.id;
    //     })) {

    //     this.filteredTags.unshift(data);
    // }
  };

  saveTag() {
    this.detail.updating = true;
    var promise = this.selectedTag.api[
      this.selectedTag.data.id ? 'update' : 'create'
    ]();
    promise.then(
      (data) => {
        this.updateModel(data, this.selectedTag.data.id);
        this.detail.updating = false;
        this.toggleTag(data);
      }, (r) => {
        this.detail.error = r.data.data;
        this.detail.updating = false;
        this.setDialog('error', r.data.data.displayName.error);
      }
    );

    return promise;
  };
  toggleTag(data) {
    this.scope.factPage.toggleTag(data);
  }

  /*deleteTag(tag) {
    if (window.confirm('Are you sure you want to delete ' + tag.displayName +
        '?')) {

      this.detail.updating = true;

      Tag.delete({
          caseId: this.currentCase.id,
          tagId: tag.id
        },
        function () {
          // select the next Tag in filtered Tags
          var index = this.filteredTags.indexOf(this.selectedTag.data);
          delete this.tags[tag.id];
          this.filterTags();
          this.setDetail(this.filteredTags[index]);

          // focus the list item in the ui to reflect selected state
          // $timeout(function () {
          angular.element('#tag-manager-list .active').focus();
          // });
        },
        function () {
          this.detail.updating = false;
        }
      );
    }
  };*/

  selectDefault() {
    // keep selection if selected Tag is in filtered Tags
    // otherwise set selected Tag to first in filtered Tags
    this.setDetail(
      this.filteredTags.indexOf(this.selectedTag && this.selectedTag.data) !==
      -1 ?
      this.selectedTag.data :
      this.filteredTags[0]
    );
  };

  setDetail(tag) {
    // set the detail view to (new) Tag

    this.selectedTag = new this.model(tag);
    // keep a backup if user cancels edit after making changes
    this.backupTag = angular.copy(tag);

    // newTag: detail view should show 'new'-specific fields
    // editMode: detail view should show editable fields
    this.detail = tag && {
      newTag: !tag.id,
      editMode: !tag.id,
      updating: false
    };
  };

  cancelDetail() {

    if (this.selectedTag.data.id) {
      // cancel should reset detail to selected Tag when editing
      this.updateModel(this.backupTag, true);

    } else {
      // cancel should select default tag when adding new
      this.selectDefault();
    }
  };

  newTag() {
    // set the detail with the new Tag
    this.setDetail({});

    this.timeout(function () {
      // Name input should be focused for fast input
      angular.element('#tag-selector-list .selector-list-new-input input')
        .focus();

      // New Source should be scrolled to if it is above view
      angular.element('#tag-selector-list > .selector-list').animate({
        scrollTop: 0
      });
    });
  };

  setSearchFilter(search) {
    this.searchQuery = search;
    this.filterTags();
  };
  setSortFilter(sortBy) {
    // sort by tag id (last added), or by sortBy (+/- displayName)
    if (this.sortFilter === sortBy) {
      this.sortFilter = '-id';
    } else {
      this.sortFilter = sortBy;
    }
    this.filterTags();
  };

  filterTags() {
    // convert object to array
    this.filteredTags = this.tags.data;
    if (this.searchQuery) {
      // filter by search query
      this.filteredTags = this.filter(this.filteredTags, {
        displayName: this.searchQuery
      });
    }
    // order by sortFilter
    this.filteredTags = this.orderBy(this.filteredTags, this.sortFilter);

    // select default Tag to open in detail panel
    this.selectDefault();
  }
};
TagsCtrl.$inject = ['$routeParams', '$scope', '$q', '$filter', '$timeout',
  'Tag', 'TagsTree', '$uibModal'
];

export default angular.module('controllers.tags', [TagModel, TagsTreeModel])
  .controller('TagsCtrl', TagsCtrl)
  .name;



// WEBPACK FOOTER //
// ./project/modals/tags/tags.controller.js